module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABKSURBVHgBxY/RCQAgCERNGqhR2qRGaRUnaIVGysAPKfowhB4cBwcPFMCJwqkWoUsOEIyYhSC9bs5qT9JDbcRpuInPfHw6XnYCLyalWQedyUUnhQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/follow.png
// module id = 69cM
// module chunks = 36